import styled, { keyframes } from "styled-components";

export const SnippetContainer = styled.div`
  width: calc(100% - 100px);
  max-width: 800px;
`;
